import styled from 'styled-components';

export const ButtonsWrapper = styled.div`
  margin-top: 20px;
  display: flex;
  gap: 10px;
  button {
    flex: 1 1 auto;
    margin: 0;
  }
`;
